// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
/*
  Responsive typography mapping
  -----------------------------
  This file aggregates named responsive typography tokens (e.g. SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL)
  and maps each breakpoint (xs, sm, md, lg, xl, 2xl) to the canonical per-breakpoint exports living in
  src/tokens/responsive/responsive-typography.generated.ts.

  Why: Consumers import the named aggregates, not the raw per-breakpoint constants. This keeps the public
  surface compact and avoids exposing every BP_* token, while still letting us reference the definitive
  per-breakpoint values internally.

  Note: An internal require() pulls in the per-breakpoint module below. The per-BP constants in this file
  are replaced with references to that module at build time.
*/
// Reference responsive per-breakpoint tokens
// eslint-disable-next-line @typescript-eslint/no-var-requires
const responsiveTypography = require('./responsive/responsive-typography.generated.js');
// Responsive Typography Generic Aggregated Tokens (generated)
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_2XL
};
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD = {
    xs: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS,
    sm: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_SM,
    md: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_MD,
    lg: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_LG,
    xl: responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XL,
    '2xl': responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_2XL
};
const common = {
    fontFamily: 'AudiType, sans-serif',
    textDecoration: 'none',
    letterSpacing: '0px'
};
export const SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER1_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER1_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER1_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER2_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER2_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER2_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_COPY_ORDER3_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER3_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER3_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER4_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER4_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER4_SHORT = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_COPY_ORDER4_SHORT_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_CAPTION_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER1_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER1_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER1_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER1_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER2_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER2_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '24px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER2_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER2_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER3_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LINK_ORDER3_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '20px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER3_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER3_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER4_NORMAL = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER4_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '16px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER4_SHORT = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '400',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SYS_TYPOGRAPHY_LINK_ORDER4_SHORT_BOLD = {
    fontFamily: 'AudiType, sans-serif',
    letterSpacing: '0px',
    fontWeight: '700',
    textDecoration: 'underline',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER1_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '16px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER2_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '20px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER3_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER3_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '12px',
    lineHeight: '16px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER4_NORMAL = {
    ...common,
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
export const SYS_TYPOGRAPHY_LABEL_ORDER4_BOLD = {
    ...common,
    fontWeight: '700',
    fontSize: '10px',
    lineHeight: '12px',
    fontStretch: '105%'
};
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER1_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Display.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order1.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER1_BOLD_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order2.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER2_BOLD_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order3.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Normal until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_2XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XS;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_SM = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_SM;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_MD = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_MD;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_LG = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_LG;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_XL;
/** @deprecation Deprecated! Use instead: Sys.Typography.Headline.Order4.Bold until 23.11.2025. */
export const SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP2_XL = responsiveTypography.SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD_BP_2XL;
export const SEM_TYPOGRAPHY_ACTION_XS_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER3_NORMAL;
export const SEM_TYPOGRAPHY_ACTION_SM_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_ACTION_MD_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SEM_TYPOGRAPHY_ACTION_MD_SUBLINE = SYS_TYPOGRAPHY_COPY_ORDER1_SHORT;
export const SEM_TYPOGRAPHY_ACTION_LG_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_FEEDBACK_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_FEEDBACK_VALUE = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_FEEDBACK_HEADLINE = {
    ...common,
    fontWeight: '400',
    fontSize: '16px',
    lineHeight: '24px',
    fontStretch: '130%'
};
export const SEM_TYPOGRAPHY_FEEDBACK_COPY = SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_FEEDBACK_RANGE = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_FEEDBACK_BADGE_INFO = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_LABEL_SMALL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_INPUT = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_APPENDIX = SYS_TYPOGRAPHY_LABEL_ORDER3_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_EXTENSION = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_CAPTION = SYS_TYPOGRAPHY_CAPTION_NORMAL;
export const SEM_TYPOGRAPHY_FORMS_RANGE = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
/** @deprecation Deprecated! Token will be removed on 28.10.25 */
export const SEM_TYPOGRAPHY_UI_CAPTION = SYS_TYPOGRAPHY_CAPTION_NORMAL;
export const SEM_TYPOGRAPHY_UI_MD_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_UI_MD_HEADLINE = SYS_TYPOGRAPHY_COPY_ORDER1_BOLD;
export const SEM_TYPOGRAPHY_UI_MD_COPY = SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_UI_MD_CAPTION = SYS_TYPOGRAPHY_CAPTION_NORMAL;
export const SEM_TYPOGRAPHY_UI_SM_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_UI_XS_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER3_NORMAL;
export const SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_NORMAL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const SEM_TYPOGRAPHY_NAVIGATION_SM_LABEL_BOLD = SYS_TYPOGRAPHY_LABEL_ORDER2_BOLD;
export const SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_NORMAL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const SEM_TYPOGRAPHY_NAVIGATION_MD_LABEL_BOLD = SYS_TYPOGRAPHY_LABEL_ORDER1_BOLD;
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_LG_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_LG_VALUE = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_MD_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_MD_VALUE = SYS_TYPOGRAPHY_LABEL_ORDER4_NORMAL;
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_MD_RANGE = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_FEEDBACK_PROGRESS_INDICATOR_SM_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_UI_AVATAR_2_XS_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER4_NORMAL;
export const CMP_TYPOGRAPHY_UI_AVATAR_XS_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER3_NORMAL;
export const CMP_TYPOGRAPHY_UI_AVATAR_SM_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_UI_AVATAR_MD_LABEL = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const CMP_TYPOGRAPHY_UI_PRODUCT_CARD_SUBLINE = SYS_TYPOGRAPHY_LABEL_ORDER1_NORMAL;
export const CMP_TYPOGRAPHY_UI_PRODUCT_CARD_PRICE_PRIMARY = SYS_TYPOGRAPHY_LABEL_ORDER2_BOLD;
export const CMP_TYPOGRAPHY_UI_PRODUCT_CARD_PRICE_SECONDARY = SYS_TYPOGRAPHY_LABEL_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_UI_TABLE_TITLE = SYS_TYPOGRAPHY_HEADLINE_ORDER4_NORMAL_BP_XS;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.TextList.MD.Copy until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_LABEL = SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL;
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_MD_COPY = SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.TextList.SM.Copy until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_SM_LABEL = SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_SM_COPY = SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.TextList.XS.Copy until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_XS_LABEL = SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL;
export const CMP_TYPOGRAPHY_UI_TEXT_LIST_XS_COPY = SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.Value.XS.Headline until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_VALUE_XS_LABEL = SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL_BP_XS;
export const CMP_TYPOGRAPHY_UI_VALUE_XS_CAPTION = SYS_TYPOGRAPHY_COPY_ORDER3_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.Value.SM.Headline until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_VALUE_SM_LABEL = SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XS;
export const CMP_TYPOGRAPHY_UI_VALUE_SM_CAPTION = SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.Value.MD.Headline until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_VALUE_MD_LABEL = SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_LG;
export const CMP_TYPOGRAPHY_UI_VALUE_MD_CAPTION = SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.Value.LG.Headline until 28.10.25 */
export const CMP_TYPOGRAPHY_UI_VALUE_LG_LABEL = SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL_BP_XL;
export const CMP_TYPOGRAPHY_UI_VALUE_LG_CAPTION = SYS_TYPOGRAPHY_COPY_ORDER1_NORMAL;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.ProductCard.Headline until 22.11.25 */
export const CMP_TYPOGRAPHY_UI_PRODUCT_TILE_HEADLINE = SYS_TYPOGRAPHY_HEADLINE_ORDER3_BOLD_BP_XS;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.ProductCard.Price.Primary until 22.11.25 */
export const CMP_TYPOGRAPHY_UI_PRODUCT_TILE_PRICE_PRIMARY = SYS_TYPOGRAPHY_COPY_ORDER1_BOLD;
/** @deprecation Deprecated! Use instead Cmp.Typography.UI.ProductCard.Price.Secondary until 22.11.25 */
export const CMP_TYPOGRAPHY_UI_PRODUCT_TILE_PRICE_SECONDARY = SYS_TYPOGRAPHY_COPY_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_UI_PRODUCT_CARD_HEADLINE = SYS_TYPOGRAPHY_HEADLINE_ORDER4_BOLD;
export const CMP_TYPOGRAPHY_UI_VALUE_XS_HEADLINE = SYS_TYPOGRAPHY_HEADLINE_ORDER2_NORMAL;
export const CMP_TYPOGRAPHY_UI_VALUE_SM_HEADLINE = SYS_TYPOGRAPHY_HEADLINE_ORDER1_NORMAL;
export const CMP_TYPOGRAPHY_UI_VALUE_MD_HEADLINE = SYS_TYPOGRAPHY_DISPLAY_ORDER3_NORMAL;
export const CMP_TYPOGRAPHY_UI_VALUE_LG_HEADLINE = SYS_TYPOGRAPHY_DISPLAY_ORDER2_NORMAL;
//# sourceMappingURL=typography.generated.js.map